// UserDashboard.js
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Card, Table } from "react-bootstrap";
import ApiService from "../../services/ApiService";
import { toast } from "react-toastify";
import {formatDate} from "../../utils/helper";
import { useLocation, useNavigate } from "react-router-dom";
import Paginator from "../../components/Paginator"; 

const MySubscription = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  // const [stats, setStats] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [user_package, setUserPackage] = useState(null);
  const [interviews, setInterviews] = useState([]);
  const [pagination, setPagination] = useState({});
  const currency = process.env.REACT_APP_CURRENCY;
  const [apiData, setApiData] = useState({
        search: "",
        page: 1,
  });
  
    const location = useLocation();
    const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    getDashboard();
  }, []);

  useEffect(() => {
    fetchMyInterviews();
  }, [apiData.page, apiData.search]);
  
  const handlePageChange = (event) => {
    setApiData(prev => ({ ...prev, page: event }));
  };


  const getDashboard = async () => {
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: "GET",
        url: `getDashboard`, // Replace with your API endpoint
      });
      const data = response.data;
      if (data.status) {
        // setStats(data.data.stats);
        setUserPackage(data.data.package);
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      setIsLoader(false);
    }
  };
  const fetchMyInterviews = async () => {
    try {
      setIsLoader(true);

      const response = await ApiService.request({
          method: "GET",
          url: "getMyInterviews", 
          params: apiData
      });
      const data = response.data;

      if (data && data.status === true) {
        setInterviews(data.data);
        setPagination(data.pagination);
      } else {
        toast.error(data.message || "Failed to fetch interviews.");
      }
    } catch (error) {
      console.error("Error fetching interviews:", error);
    } finally {
      setIsLoader(false);
    }
  };

  const handleInterviewClick = (interview) => {
    const status = interview.user_interview?.status?.trim().toLowerCase();
    if (status === "active") {
      navigate('/dashboard?tab=interviews-details&id='+interview.id);
    } else {
      toast.error("Buy interview first.");
    }
    
  };

  const handlePurchase = async (id) => {
    if (!id) {
      toast.error("The interview ID is required");
      return;
    }else{
      navigate('/checkout?interview_id='+id);
    }
    
  };

  return (
    <div>

      <Card className="p-2 mt-3 card-main">
        <Card.Body>
          <Card.Title className="border-bottom pb-3 mb-3">Membership Report </Card.Title>
          {!isLoader && 
          <div>
            {user_package ? (
              <div className="mb-3">
                <h4>{user_package.package.name}</h4>
               
                <p className="fw-lighter">
                  <span className="fw-normal ">Status: <span  className={user_package.status=="Active"?"badge bg-success mx-2":"badge bg-danger mx-2"}>{user_package.status}</span> </span>
                </p>
                <p className="fw-lighter">
                  <span className="fw-normal">Purchased at:</span>
                  <span className="fw-semibold mx-2">{formatDate(user_package.created_at,'DD MMM YYYY, hh:mm A')} </span> 
                </p>

                <p className="fw-lighter">
                  <span className="fw-normal">Valid Until:</span>
                  <span className="fw-semibold mx-2">{formatDate(user_package.expiry_date,'DD MMM YYYY, hh:mm A')} </span> 
                </p>
              </div>
            ) : (
              <div className="mb-3 alert alert-danger fs-6 fw-semibold">
                You don't have purchased any subscription
              </div>
            )}

            <p>
            <NavLink to="/packages" className="btn btn-base "> Upgrade Plan</NavLink>.
            </p>
          </div>
          }
        </Card.Body>
      </Card>
      <Card className="p-2 mt-3 card-main">
        <Card.Body>
          <Card.Title className="border-bottom pb-3 mb-3">My Courses</Card.Title>
          {!isLoader && 
            <div className="d-flex flex-wrap px-0">
            {interviews.map((interview, index) => (
              <div
                className="col-md-4 col-sm-6 mb-4 cards-interview px-2 cursor-pointer"
                key={index}     onClick={() => handleInterviewClick(interview)}>
                <div className="card h-100 shadow-sm">
                  <div className="card-img-top bg-light">
                    <img src={interview.thumbnail} className="w-100" alt="" />
                  </div>
                  <div className="card-body">
                    <h5   className="card-title " >
                      {interview.title}
                    </h5>
                      <p className="badge bg-base">
                      {interview?.category?.title }
                      </p> <br />
                    <p className="card-text fs-5 fw-semibold float-start">
                      Price: {currency} {interview.price}
                    </p>
                    {interview.user_interview ? (
                      <p className="badge bg-success float-end">
                        {interview.user_interview.status}
                      </p>
                    ) : (
                      <button
                        className="btn btn-sm btn-base float-end"
                        onClick={() => handlePurchase(interview.id)}
                      >
                        Buy Now
                      </button>
                    )}
                    <br /> <br />

                    <p className="card-text text-muted ">
                      {interview.description.slice(0, 120)}
                    </p>
                    
                  </div>
                </div>
              </div>
            ))}
            {interviews.length === 0 && <div>No courses available.</div>}
            {pagination.total_pages > 1 && (
              <Paginator
                  page={pagination.current_page}
                  rows={pagination.per_page}
                  totalRecords={pagination.total_records}
                  onPageChange={handlePageChange}
              />
            )}
            </div>
          }
        </Card.Body>
      </Card>
    </div>
  );
};

export default MySubscription;
